/**
 * @Author:
 * @Description:
 * @DateTime: Created in 22:33 2020/10/9
 */
import _ from 'lodash'
import PublicApi, {PublicApiI} from "../util/publicApi";
import {Result} from "../types/base";
import {CommonUtil} from "../util/commonUtil";

interface EnumCashI {
	list: {id: number,name: string}[]
	nameToId?: {[str: string]: number}
	idToName?: {[num: number]: string}
}
let promiseCash:{[num:number]: Promise<Result<Array<PublicApiI.EnumResI>>>} = {}

let enumCashMap: {[num: number]: EnumCashI} = {}
// 每次
let enumTypes:Set<number> = new Set()

export default class EnumFactory {

	constructor (enumType: number[]) {
		this.enumType = enumType
	}

	static clearCache() {
		promiseCash = {}
		enumCashMap = {}
		enumTypes = new Set<number>()
	}

	private enumType: number[]


	async initPromise (id: number) {
		if(!promiseCash[id]) {
			// 合并去重
			let idsSet = new Set([...this.enumType,...Array.from(enumTypes)])
			// 将已经缓存的删除
			for (let key in promiseCash) {
				if(idsSet.has(+key)) {
					idsSet.delete(+key)
				}
			}
			let ids = Array.from(idsSet)
			let dictPromise = PublicApi.queryEnum({ids: ids.join(',')})
			for (let i = 0, l = ids.length; i < l; i++) {
				let item = ids[i];
				promiseCash[item] = dictPromise
			}
			// 清空
			enumTypes = new Set<number>()
		}

		let {ret, rc} = await promiseCash[id]
		if(enumCashMap[id]) {
			return
		}
		if(rc === 0) {
			_.forEach(ret, (item)=>{
				enumCashMap[item.id] = 	{
					list: item.items
				}
			})
		} else {
			delete enumCashMap[id]
			delete promiseCash[id]
		}
	}

	/**
	 * 获取枚举条目
	 * @param {number} dictionaryCategoryId 类别id
	 * @returns {Promise<Array<EnumResI>>}
	 */
	async getDictList (enumType: number): Promise<Array<{id: number,name: string}>> {
		if(!enumCashMap[enumType]) {
			enumTypes.add(enumType)
			await CommonUtil.sleep(0)
			await this.initPromise(enumType)
		}
		return enumCashMap[enumType].list
	}

	/**
	 * 获取枚举名字
	 * @param {number} enumType 枚举所属类别
	 * @param {number} id	枚举id
	 * @returns {Promise<string>}
	 */
	async getNameById (enumType: number,id: number): Promise<string> {
		if(!enumCashMap[enumType]) {
			enumTypes.add(enumType)
			await CommonUtil.sleep(0)
			await this.initPromise(enumType)
		}
		this.initNameById(enumType)
		let idToName:any = enumCashMap[enumType].idToName
		return idToName[id]
	}
	initNameById(enumType: number) {
		if(!enumCashMap[enumType].idToName) {
			 let idToName = {}
			_.forEach(enumCashMap[enumType].list,(item)=>{
				idToName[item.id] = item.name
			})
			enumCashMap[enumType].idToName = idToName
		}
	}

	/**
	 * 获取枚举id
	 * @param {number} enumType 枚举所属类别
	 * @param {string} name	枚举name
	 * @returns {Promise<string>}
	 */
	async getIdByName (enumType: number,name: string): Promise<number> {
		if(!enumCashMap[enumType]) {
			enumTypes.add(enumType)
			await CommonUtil.sleep(0)
			await this.initPromise(enumType)
		}
		this.initIdByName(enumType)
		let nameToId:any = enumCashMap[enumType].nameToId
		return nameToId[name]
	}

	initIdByName(enumType: number) {
		if(!enumCashMap[enumType].nameToId) {
			let nameToId = {}
			_.forEach(enumCashMap[enumType].list,(item)=>{
				nameToId[item.name] = item.id
			})
			enumCashMap[enumType].nameToId = nameToId
		}
	}
}
